import React, { useState,useRef, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";

const styles = () => ({
    trackInfos: {
        position:"relative",
        userSelect: "none",
        zIndex: "22",
        cursor: "text",
        display: "flex",
        transitionProperty: "opacity",
        transitionDuration: ".15s",
        "&.hidden": {
            opacity: 0,
            transitionDuration: "0s",
        },
        backgroundColor: "rgba(0, 0, 0, 0.25)",
        width: "35%",
        marginLeft:"auto",
        marginBottom:"auto",
    },
    infos:{
        position:"absolute",
        top: "0",
        left:"-190%",
        listStyleType:"none",
        '& li':{
            color:"white",
        }
    }
});

const PeerStatistics = (props) => {
    const { consumer , score} = props;
    const classes = props.classes;
    let bytesPrev = useRef("");
    const [result, setResult] = useState({ bitrate: "", fps: "", frameWidth: "", frameHeight: "", packetLoss:"" , jitter:""});

    useEffect(() => {
        const intervalId = setInterval(() => {
            getStatics();
        }, 1000)

        return () => clearInterval(intervalId);

    }, [])


    const getStatics = () => {

        consumer.getStats().then((stats) => stats.forEach(report => {
                if (report.type === 'inbound-rtp' && report.mediaType === "video")
                {
                    let bitrate;
                    const now = report.timestamp;
                    const bytes = report.bytesReceived;
                    if (report.lastPacketReceivedTimestamp) {
                        bitrate = 8 * (bytes - bytesPrev.current) / (now - report.lastPacketReceivedTimestamp);
                        bitrate = Math.floor(bitrate);
                    }
                    bytesPrev.current = bytes;
                    if (bitrate) {
                        bitrate += ' kbits/sec';
                    }

                    setResult({...result,bitrate: bitrate.toString(), fps:report.framesPerSecond.toString(),frameHeight: report.frameHeight.toString(),frameWidth: report.frameWidth.toString(),jitter:report.jitter.toString(),packetLoss: report.packetsLost.toString()});
                }
            }

        ))
    }


    return (
        <>
            <div className={classes.trackInfos}>
                <ol className={classes.infos}>
                    <li>Connection : {score > 5 ? "Good" : "Poor"}</li>
                    <li>FPS : {result.fps}</li>
                    <li>Resolution: {result.frameWidth + "x" + result.frameHeight}</li>
                    <li>Bitrate: {result.bitrate}</li>
                    <li>Jitter: {result.jitter}</li>
                    <li>Packet Loss: {result.packetLoss}</li>
                </ol>
            </div>
        </>
    );
}

export default withStyles(styles,{withTheme: true })(PeerStatistics);
